import {cs} from "@Common/react/chain-services";
import {ui} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {summaryLines} from "../common/summary-lines-expo";

import {PdfDownload} from "./pdf-download";

export const pdfDownloadModules = ({}) => [
    {
        load: ({pdfDownload2}, rootNext) => cs(
            ({}) => rootNext(pdfDownload2 && {
                summaryLines: pdfDownload2.state.value && [{
                    label: "File Download",
                    amount: pdfDownload2.pdfDownloadPrice,
                }],

                ui: PdfDownload({
                    state: pdfDownload2.state,
                    pdfDownloadPrice: pdfDownload2.pdfDownloadPrice,
                }),
            }),
        ),
        requires: ["pdfDownload2"],
        expo: [ui("pdfDownload"), summaryLines],
    },
];
